import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

// Layout
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/Banner.png";

// ENV
const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: "",
    message: "",
    color: "info",
    icon: "info",
  });

  const closeSB = () => setSnackbar({ ...snackbar, open: false });

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setSnackbar({
          open: true,
          title: "Errore",
          message: "Token mancante.",
          color: "error",
          icon: "error",
        });
        setTimeout(() => navigate("/app/authentication/sign-in"), 3000);
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/verify.php`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
        });
        const data = await response.json();

        if (!response.ok) {
          setSnackbar({
            open: true,
            title: "Errore",
            message: data.message || "Verifica fallita.",
            color: "error",
            icon: "error",
          });
        } else {
          setSnackbar({
            open: true,
            title: "Successo",
            message: "Email verificata con successo!",
            color: "success",
            icon: "check",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          title: "Errore",
          message: error.message || "Errore di rete.",
          color: "error",
          icon: "error",
        });
      } finally {
        setTimeout(() => navigate("/app/authentication/sign-in"), 3000);
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox p={4} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" mb={2}>
            Verifica in corso...
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Attendi mentre verifichiamo la tua email.
          </MDTypography>
        </MDBox>
      </Card>

      <MDSnackbar
        open={snackbar.open}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.message}
        onClose={closeSB}
        close={closeSB}
        bgWhite
      />
    </CoverLayout>
  );
};

export default VerifyEmail;

